module.exports = __webpack_public_path__ + "img/icon2.e828fc24.png";